import store from '@src/store';
import { EVENTBUS_PUBLISH } from '@src/app/eventLogging/actions';
export const CREATE_GA_EVENT = 'CREATE_GA_EVENT';
import ReactGA from 'react-ga4';

export type Actions = {
    CREATE_GA_EVENT: { type: typeof CREATE_GA_EVENT, payload: any| null}
  };

export const actionCreators = {
     createGAEvent: (payload): void => {
        let intValue = payload.value;
        let floatValue = payload.value;
        if (payload.value) {
          if (Number.isInteger(payload.value)) {
            floatValue = parseFloat((payload.value / 100).toFixed(2)) ;
            intValue = payload.value;
          } else {
            floatValue = payload.value;
            intValue = payload.value * 100;
            // put inValue in payload since eventBus always assumes an integer value since it is "corrected" in the backend
            payload.value = intValue; 
          }
        }
        if (store.getState().userState.directViewLogin) {
          payload.category = 'DirectView ' + payload.category;
        }
        store.dispatch({type: EVENTBUS_PUBLISH, payload: payload});
        ReactGA.event('GC: ' + payload.category,
        {
            result: payload.action,
            prodId: payload.label,
            value: floatValue,
            fullCategory: 'GC: ' + payload.category
        });
    }
  };